import React from 'react'
import css from './FullWidthContent.module.css'

export default ({ children }) => (
  <div className={css.container}>
    <div className={css.insideContainer}>{children}</div>
  </div>
)
